<!--
// app/pages/[region]/tier-list.vue
-->
<script setup lang="ts">
import LayoutTierListKwcClubs from "~/components/pages/region-tier-list/LayoutTierListKwcClubs.vue";
import { useRegions } from "~/composables/regions";
import { useNuxtApp } from "#imports";

const { $t, $getLocale } = useNuxtApp();

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-spain",
    "not-found-queens",
    "not-found-italy",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
    "not-found-mena",
  ],
});

useHead({
  script: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/dom-to-image/2.6.0/dom-to-image.min.js",
      tagPosition: "head",
      tagPriority: "high",
    },
  ],
});

const { isWorldCup, isNations } = useRegions();
const locale = $getLocale();

if (isNations) {
  const homeNationsUrl = "/" + locale + "/kwc-nations";
  await navigateTo(homeNationsUrl, { redirectCode: 302 });
}
</script>

<template>
  <layout-tier-list-kwc-clubs v-if="isWorldCup"></layout-tier-list-kwc-clubs>
</template>

<style scoped></style>
